<template>
  <b-card>
    <b-modal
      id="cancel-booking"
      title="Cancel Booking"
      hide-footer
      no-close-on-backdrop
    >
      <h4 class="mb-2">
        Are you sure you want to cancel this booking?
      </h4>
      <v-select
        v-model="selectedCancellationReason"
        :options="cancellationReasons"
        class="mb-2"
        placeholder="Cancellation Reason"
      />
      <b-form-radio-group
        v-model="feesOn"
        class="mb-2"
        stacked
        :options="feesOnOptions"
      />
      <b-button
        variant="danger"
        block
        :disabled="!selectedCancellationReason || applyingAction"
        @click="cancelBooking"
      >
        <b-spinner
          v-if="applyingAction"
          small
        />
        <span v-else>Cancel Booking</span>
      </b-button>
    </b-modal>
    <b-card-title>Booking Actions</b-card-title>
    <b-row>
      <b-col md="3">
        <b-button
          variant="danger"
          @click="$bvModal.show('cancel-booking')"
        >
          Cancel Booking
        </b-button>
      </b-col>
      <!-- <b-col md="3">
        <b-button
          disabled
          variant="primary"
        >
          Re-Assign Booking
        </b-button>
      </b-col> -->
    </b-row>
  </b-card>

</template>
<script>
import { computed, ref } from '@vue/composition-api'
import {
  BCard, BRow, BCol, BCardTitle, BButton, BModal, BSpinner, BFormRadioGroup,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import axiosIns from '@/libs/axios'

export default {
  components: {
    BCard,
    BCardTitle,
    BFormRadioGroup,
    BRow,
    vSelect,
    BSpinner,
    BModal,
    BButton,
    BCol,
  },
  props: {
    bookingStatus: {
      type: String,
      required: true,
    },
  },
  setup(props, ctx) {
    const feesOnOptions = computed(() => {
      const temp = [{
        text: 'without fees on both driver & user',
        value: null,
      }]

      if (props.bookingStatus !== 'CREATED') {
        temp.unshift({
          text: 'Fees on driver',
          value: 'FEES_ON_DRIVER',
        },
        {
          text: 'Fees on user',
          value: 'FEES_ON_USER',
        })
      }

      return temp
    })

    const bookingId = ctx.root.$route.params.id
    const cancellationReasons = ref([])
    const applyingAction = ref(false)
    const selectedCancellationReason = ref()
    const feesOn = ref(null)

    const cancelBooking = async () => {
      try {
        applyingAction.value = true
        await axiosIns.patch(`/booking/${bookingId}`, {
          cancellationReason: selectedCancellationReason.value,
          cancelationFeesType: feesOn.value || undefined,
        })
        ctx.root.$bvModal.hide('cancel-booking')
        ctx.emit('action-applied')
      } finally {
        applyingAction.value = false
      }
    }
    const fetchCancellations = async () => {
      const result = await axiosIns.get('/booking/cancellation-reason')
      cancellationReasons.value = result.data.data.cancellationReasons.map(cr => cr.reason.en)
    }

    fetchCancellations()

    return {
      cancelBooking,
      cancellationReasons,
      selectedCancellationReason,
      applyingAction,
      feesOn,
      feesOnOptions,
    }
  },
}
</script>
